import FAQ from "./FAQ";

const faqs = [
  {
    question: "How does billing work?",
    answer:
      "You can choose between monthly or annual billing. Annual plans are billed once per year and save you up to 20%. All plans can be cancelled at any time.",
  },
  {
    question: "What's a message?",
    answer:
      "Every time you prompt Flowstep, that's one message. If you hit an error, that won't count toward your message limit.",
  },
  {
    question: "When do my limits reset?",
    answer:
      "Monthly quotas (messages, exports, copy to Figma) reset on the 1st of the month. Daily limits reset at 00:00 UTC.",
  },
  {
    question: "What about currency and pricing?",
    answer: "Prices are shown only in USD for now.",
  },
  {
    question: "Can I cancel anytime?",
    answer:
      "Yes, you can cancel your subscription at any time. Your access will continue until the end of your current billing period.",
  },
  {
    question: "Do you offer invoices?",
    answer:
      "Yes, all paid plans receive automatic invoices after each billing cycle. You can download them from your account dashboard at any time.",
  },
  {
    question: "How secure is Flowstep?",
    answer:
      "We take security seriously. All data is encrypted in transit and at rest. For more details, check our Security & Privacy page.",
  },
];

export function PricingFAQ() {
  return <FAQ faqs={faqs} />;
}
